import WishlistAvailabilityState from "@dana/Store/Data/WishlistAvailability/WishlistAvailabilityState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { PaginationModel, ProductModel, WishListLineModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: WishlistAvailabilityState = {
    showPopup: false,
    isLoading: false,
    wishList: null,
    wishListLineCollection: null
};

const wishlistAvailabilityImmerReducer = createTypedReducerWithImmer(initialState, {
    "WishlistAvailability/Init": (draft: Draft<WishlistAvailabilityState>) => {
        draft = { ...initialState };    
        return draft;
    },
    "WishlistAvailability/ShowPopup": (draft: Draft<WishlistAvailabilityState>, action: { showPopup: boolean }) => {
        draft = { ...draft, showPopup: action.showPopup };
        return draft;
    },
    "WishlistAvailability/IsLoading": (draft: Draft<WishlistAvailabilityState>, action: { isLoading: boolean }) => {
        draft = { ...draft, isLoading: action.isLoading };
        return draft;
    },
    "WishlistAvailability/SetWishlist": (draft: Draft<WishlistAvailabilityState>, action: { wishList: WishListModel | null , wishListLineCollection: WishListLineModel[] | null }) => {
        draft = {
            ...draft,
            wishList: action.wishList,
            wishListLineCollection:action.wishListLineCollection
        };
       
        return draft;
    },
});

(reducers as any).wishlistAvailabilityState = wishlistAvailabilityImmerReducer;

type WishlistAvailabilityReducers = {
    wishlistAvailabilityState: typeof wishlistAvailabilityImmerReducer;
};

export type WishlistAvailabilityActions = Parameters<WishlistAvailabilityReducers[keyof WishlistAvailabilityReducers]>[1] | AnyAction;

